import { abreviarNome } from 'libs/StringUteis';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useModalHistory } from 'routes/admin/hook/useModalHistory';
import { formulario } from '../formulario.json';
import CartaoCliente from '../partial/cartao';
import { IModalTransporte } from '../../../../../types/modules/modalTransporte';
import { GRAPHQL_CONFIGURACAO } from '../../../../../gql/configuracao';
import { useQuery } from '@apollo/client';

export const useSelectClient = (props) => {
    const { data, loading: loadingData } = useQuery<{
        recuperarModalTransporte?: IModalTransporte[];
    }>(GRAPHQL_CONFIGURACAO, {
        fetchPolicy: 'no-cache',
    });
    const [optionsTransport, setOptionsTransport] = useState([]);
    useEffect(() => {
        if (!loadingData && data) {
            const newData = [];
            data.recuperarModalTransporte.forEach((item) => {
                if(item.ativo === true)
                    newData.push({
                        value: item.id,
                        label: item.nome,
                    }) 
            });
            setOptionsTransport(newData);
        }
    }, [loadingData, data]);
    const [selectedTransporteId, setSelectedTransporteId] = useState<
        string | number
    >(props.itemSelecionado?.modalTransporteId ?? null);
    const handleChangeTransporte = useCallback((selected) => {
        setSelectedTransporteId(selected?.value ?? null);
    }, []);
    const [loading, setLoading] = useState(false);
    const history = useModalHistory();
    const handleEdit = useCallback(
        async ({ fieldName }) => {
            history.push(
                `editar~cliente/${props.itemSelecionado.id}/${fieldName}`
            );
        },
        [props]
    );

    const response = useMemo(() => {
        let dataForm: any = [
            {
                type: 'hidden',
                name: 'clienteId',
            },
            {
                type: 'hidden',
                name: 'endereco',
            },
        ];
        if (!props.loadingInitial && !props.defaultValue.novo) {
            dataForm.push({
                type: 'select-async',
                // label: 'Nome, email ou telefone',
                // toolTipLegend:
                //     'Para criar um novo cliente é necessário no mínimo 5 caracteres. É obrigatório informar o nome completo.',
                placeholder: 'Digite ou selecione o nome do cliente',
                name: 'nomeCompleto',
                onChange: props.handleSetDefaultValue,
                loadOptions: props.loadOptions,
                defaultValue: props.defaultValue,
            });
        } else if(props.defaultValue.novo){
            dataForm.push({
                type: 'text',
                label: 'Nome',
                toolTipLegend:
                    'Para criar um novo cliente é necessário no mínimo 5 caracteres. É obrigatório informar o nome completo.',
                placeholder: 'Digite o nome completo do cliente',
                name: 'nomeCompleto',
                defaultValue: props.defaultValue.value,
                stylWarp: {
                    marginTop: 30,
                }
            });
        }
        if (props.itemSelecionado) {
            dataForm.push({
                type: 'custom-component',
                component: CartaoCliente,
                handleClick: handleEdit,
                nomeCompleto: abreviarNome(props.itemSelecionado?.nomeCompleto),
                telefoneFixo: props.itemSelecionado?.telefoneFixo,
                telefoneCelular: props.itemSelecionado?.telefoneCelular,
                email: props.itemSelecionado?.email,
                id: props.itemSelecionado?.id,
            });
        }
        if (props.defaultValue.novo) {
            dataForm = dataForm.concat(formulario);
        }
        if(props.itemSelecionado){
            dataForm.push({
                type: 'select-simple',
                label: 'Tipo de Transporte',
                // toolTipLegend:
                //     'Para criar um novo cliente é necessário no mínimo 5 caracteres. É obrigatório informar o nome completo.',
                placeholder: 'Selecione o tipo de transporte',
                name: 'modalTransporteId',
                options: optionsTransport,
                onChange: handleChangeTransporte,
                stylWarp: {
                    marginTop: 30
                }
            });
            if (Number(selectedTransporteId) === 1) {
                dataForm.push({
                    type: 'checkbox',
                    name: 'coletarComBau',
                    options: [
                        { id: '1', value: '1', label: 'Coletar com baú' },
                    ],
                    stylWarp: {
                        marginTop: 10
                    }
                });
            }
        }
        if (props.itemSelecionado || props.defaultValue.novo) {
            dataForm.push({
                type: 'button',
                value: props.defaultValue.novo
                    ? 'Salvar novo cliente'
                    : 'Ir para endereço',
                loading,
            });
        }
        
        return dataForm;
    }, [props, optionsTransport, loading, selectedTransporteId, handleChangeTransporte]);

    return { formsChilds: response, setLoading };
};
